import {HttpErrorResponse, HttpInterceptorFn} from '@angular/common/http';
import {inject} from '@angular/core';
import {catchError, switchMap, throwError} from 'rxjs';
import {CSRF_HEADER, HubApiService} from './hub-api.service';

export const hubSessionInterceptor: HttpInterceptorFn = (request, next) => {
  const hubApi = inject(HubApiService);

  return next(request).pipe(
    catchError((error: unknown) => {
      if (!(error instanceof HttpErrorResponse)) {
        return throwError(() => error);
      }

      if (error.status === 403 && error.error?.error === 'csrf' && request.headers.has(CSRF_HEADER)) {
        return hubApi.loadSession().pipe(
          switchMap((session) => next(request.clone({
            setHeaders: {[CSRF_HEADER]: session.csrfToken ?? ''}
          })))
        );
      }

      if (error.status === 401 && error.error?.error === 'unauthorized') {
        hubApi.loadSession().subscribe();
      }

      return throwError(() => error);
    })
  );
};
